import { AnimatePresence, motion, useReducedMotion } from "motion/react";
import { useNavigation } from "react-router";

export function RouteLoadingBar() {
  const navigation = useNavigation();
  const shouldReduceMotion = useReducedMotion();

  return (
    <AnimatePresence>
      {navigation.state === "loading" && (
        <motion.div
          role="progressbar"
          className="pointer-events-none fixed inset-x-0 top-0 z-200 h-0.5 overflow-hidden bg-primary-100"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15 }}
        >
          <motion.div
            className="h-full w-2/5 bg-primary motion-reduce:w-full"
            initial={shouldReduceMotion ? false : { x: "-100%" }}
            animate={{ x: shouldReduceMotion ? "0%" : "250%" }}
            transition={
              shouldReduceMotion
                ? { duration: 0 }
                : { duration: 1, ease: "easeInOut", repeat: Infinity }
            }
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
